<form [formGroup]="formGroup">
  <div class="form-check form-switch">
    <input
      class="form-check-input"
      type="checkbox"
      [id]="'switch-' + inputSetting.fieldName"
      [formControlName]="inputSetting.fieldName"
      [required]="isRequired"
    />
    <label class="form-check-label" [for]="'switch-' + inputSetting.fieldName">
      {{ inputSetting.label }}
    </label>
  </div>
</form>

